<template>
    <div v-loading="mixinLoading">
        <Query ref="query" key="adGroupQuery" :page="pageName" @query-click="handleQueryClick" :list="allFilterList"/>
        <!-- 自定义列 -->
        <CustomizeModal
        ref="refcustomizeModal"
        :customList="assignObj"
        :selectList="selectList"
        :customBtnLoading="customBtnLoading"
        @getCustomList="getCustomList"/>
        <!-- 表格 -->
        <div class="com-table-view-apple">
            <div class="operation-box" id="operation-box">
                <div class="operation-left">
                    <el-button type="primary" size="mini" v-if="pageFuncNames.includes('add_adgroup')" :loading="addLoading" @click="handleClickAdd">Create New Ad Group</el-button>
                    <el-divider direction="vertical" v-if="pageFuncNames.includes('add_adgroup')"></el-divider>

                    <el-menu
                        v-if="isHasBatchAuth"
                        class="apple-cascader"
                        mode="horizontal"
                        @select="(val)=>handleCommand(val, '')">
                        <el-submenu index="1" :popper-append-to-body="false">
                            <template slot="title"><span>Batch Edit</span></template>
                            <el-menu-item index="1" v-if="!isHasAuth('edit_adgroup_status')" :disabled="isEmptySelection"><span class="text-color-success">Switch - Run</span></el-menu-item>
                            <el-menu-item class="err-menu-item" index="2" v-if="!isHasAuth('edit_adgroup_status')" :disabled="isEmptySelection"><span class="text-color-error">Switch - Pause</span></el-menu-item>
                            <el-menu-item class="err-menu-item" index="5" v-if="!isHasAuth('del')" :disabled="isEmptySelection"><span class="text-color-error">Delete</span></el-menu-item>
                        </el-submenu>
                    </el-menu>
                    <span style="padding-left: 8px;" v-if="multipleSelection.length>0">{{multipleSelection.length}} Items Selected</span>

                </div>
                <div class="operation-right">
                    <el-button
                        icon="el-icon-s-operation"
                        size="mini"
                        @click="handleShowDefineRow">Custom Columns</el-button>
                    <el-button
                        icon="el-icon-download"
                        size="mini"
                        v-if="!isHasAuth('export')"
                        :loading="exportLoading"
                        @click="handleExport">Export</el-button>
                </div>
            </div>

            <div style="min-height: 200px;">
                <el-table
                    :data="tableData"
                    style="width: 100%;"
                    ref="multipleTable"
                    :row-key="getRowKey"
                    :header-cell-style="{background:'#e8eaec',color:'#333'}"
                    @selection-change="handleSelectionChange"
                    @sort-change="handlesortchange"
                    v-loading="!mixinLoading && loading"
                >
                    <!--复选框）-->
                    <el-table-column
                        type="selection"
                        width="50"
                        align="center"
                        fixed="left"
                        :selectable="selectable"
                        >
                    </el-table-column>
                    <!-- 默认 -->
                    <el-table-column
                        :prop="column.name"
                        :label="column.display_name"
                        :align="column.align"
                        :min-width="column.width"
                        :fixed="column.fixed !='' ? column.fixed : false"
                        :sortable="getsortable(column['field_type'], column.name)"
                        v-for="(column, index) in columns"
                        :key="index"
                        :render-header="(h, values)=>renderHeader(h, values, column)"
                        >
                        <template slot-scope="scope">
                            <div v-if="scope.$index===0" class="">
                                <span v-if="column.name==firstColumnName">Total</span>
                                <div v-else-if="scope.row[column.name]">
                                    <div class="currency_flex" v-if="getcurrency(scope.row, column.name)['has']">
                                        <div class="column_name text-nowrap">
                                            {{ getcurrency(scope.row, column.name)['name'] }}
                                        </div>
                                        <div class="column_currency">
                                            {{ getcurrency(scope.row, column.name)['currency'] }}
                                        </div>
                                    </div>
                                    <div class="currency_flex" v-else> {{ getcurrency(scope.row, column.name)['name'] }}</div>
                                </div>
                                <span v-else>-</span>
                            </div>
                            <template v-else>
                                <div :class="{ lineheightmax: getshowTip(column.name) }"
                                     v-if="column.field_type=='1' && column.name=='adgroup_name'"
                                     class="text-color-primary pointer" @click="handleClickAdGroupName(scope.row)">
                                    {{scope.row[column.name]}}
                                </div>

                                <!-- 开关 -->
                                <el-switch
                                    v-else-if="column.field_type=='1' && column.name=='adgroup_status'"
                                    v-model="scope.row.adgroup_status"
                                    :disabled="isHasAuth('edit_adgroup_status') || !selectable(scope.row) || scope.row['adgroup_status_disabled']"
                                    active-value="ENABLED"
                                    inactive-value="PAUSED"
                                    @change="(val)=>handleSwith(scope.row, column.name, val)">
                                </el-switch>

                                <!-- 操作 -->
                                <div class="table_operate" v-else-if="column.field_type=='1' && column.name=='operate'">
                                    <el-button type="text" :disabled="!pageFuncNames.includes('edit')|| !selectable(scope.row)" @click="handleEdit(scope.row)">Edit</el-button>
                                    <el-button type="text" @click="handledrawer(scope.$index)" class="mr10">Details</el-button>
                                    <el-dropdown @command="(val)=>handleCommand(val, scope.$index)">
                                    <span class="el-dropdown-link">
                                        <div style="transform: rotate(90deg);cursor: pointer;">
                                            <i class="el-icon-more"></i>
                                        </div>
                                    </span>
                                        <el-dropdown-menu slot="dropdown" v-if="!isHasAuth('del')">
                                            <el-dropdown-item command="6" :disabled="scope.row['delbtn_status_disabled'] || !selectable(scope.row)">
                                                <span class="menude" :class="{menuDisabled: (scope.row['delbtn_status_disabled'] || !selectable(scope.row)) ? true : false}">Delete</span>
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                    <!-- <el-popconfirm
                                        title="这是一段内容确定删除吗？"
                                        >
                                        <el-button slot="reference">Delete</el-button>
                                    </el-popconfirm> -->
                                </div>

                                <!-- 默认最高点击付费出价 -->
                                <div v-else-if="column.field_type=='1' && column.name=='default_bid_amount'" class="custom_input" :class="[(active == scope.$index && first_name == column.name) ? 'active' : '']" ref="table_first">
                                    <el-input
                                        v-if="(active != scope.$index || first_name != column.name)"
                                        size="mini"
                                        class="custom_input_el"
                                        :value="formatNumberWithCommas(Number(scope.row.default_bid_amount),'default_bid_amount')"
                                        @focus="handleDeFocus(scope.row.default_bid_amount, scope.$index, column.name, 'first')"
                                        readonly
                                        ref="myParagraphread"
                                        :disabled="isHasAuth('edit_default_bid_amount') || !selectable(scope.row)"
                                    >
                                        <template slot="append" v-if="(active != scope.$index || first_name != column.name)">{{scope.row.default_bid_amount_currency}}</template>
                                    </el-input>
                                    <el-input
                                        v-if="(active == scope.$index && first_name == column.name)"
                                        size="mini"
                                        placeholder="Please Enter"
                                        class="custom_input_el"
                                        v-model="scope.row.default_bid_amount"
                                        @blur="handleBlur(scope.$index)"
                                        @input="(value)=>handleInput(value, scope.row, column.name)"
                                        ref="myParagraphread"
                                        :disabled="isHasAuth('edit_default_bid_amount') || !selectable(scope.row)"
                                    >
                                        <template slot="append" v-if="(active != scope.$index && first_name == column.name)">{{scope.row.default_bid_amount_currency}}</template>
                                    </el-input>
                                    <div class="custom_input_btn" v-if="(active == scope.$index && first_name == column.name)">
                                        <button class="custom_input_success" :class="{'btn-disabled': scope.row['edit_default_bid_amount_disabled']}" :disabled="scope.row['edit_default_bid_amount_disabled']" @click="handleDeOK(scope.row, 'default_bid_amount', 'first')"><i class="el-icon-check"></i></button>
                                        <button class="custom_input_close" :class="{'btn-disabled': scope.row['edit_default_bid_amount_disabled']}" :disabled="scope.row['edit_default_bid_amount_disabled']" @click="handleDeClose(scope.row, scope.$index, 'first')"><i class="el-icon-close"></i></button>
                                    </div>
                                </div>

                                <!-- 每次转化费用上限 -->
                                <div v-else-if="column.field_type=='1' && column.name=='cpa_goal'" class="custom_input" :class="[(active == scope.$index && second_name == column.name) ? 'active' : '']" ref="table_second">
                                    <el-input
                                        v-if="(active != scope.$index || second_name != column.name)"
                                        size="mini"
                                        class="custom_input_el"
                                        :value="formatNumberWithCommas(Number(scope.row.cpa_goal))"
                                        @focus="handleCpaFocus(scope.row.cpa_goal, scope.$index, column.name, 'second')"
                                        readonly
                                        ref="myParagraphread"
                                        :disabled="isHasAuth('edit_cpa_goal') || !selectable(scope.row)||(scope.row.supply_source!='搜索结果'&&scope.row.supply_source!='Search Results')"
                                    >
                                        <template slot="append" v-if="(active != scope.$index || second_name != column.name)">{{scope.row.cpa_goal_currency}}</template>
                                    </el-input>
                                    <el-input
                                        v-if="(active == scope.$index && second_name == column.name)"
                                        size="mini"
                                        placeholder="Please Enter"
                                        class="custom_input_el"
                                        v-model="scope.row.cpa_goal"
                                        @blur="handleBlur(scope.$index)"
                                        @input="(value)=>handleInput(value, scope.row, column.name)"
                                        ref="myParagraphread"
                                        :disabled="isHasAuth('edit_cpa_goal') || !selectable(scope.row)"
                                    >
                                        <template slot="append" v-if="(active != scope.$index && second_name == column.name)">{{scope.row.cpa_goal_currency}}</template>
                                    </el-input>
                                    <div class="custom_input_btn" v-if="(active == scope.$index && second_name == column.name)">
                                        <button class="custom_input_success" :class="{'btn-disabled': scope.row['edit_cpa_goal_disabled']}" :disabled="scope.row['edit_cpa_goal_disabled']" @click="handleCpaOK(scope.row, 'cpa_goal', 'second')"><i class="el-icon-check"></i></button>
                                        <button class="custom_input_close" :class="{'btn-disabled': scope.row['edit_cpa_goal_disabled']}" :disabled="scope.row['edit_cpa_goal_disabled']" @click="handleCpaClose(scope.row, scope.$index, 'second')"><i class="el-icon-close"></i></button>
                                    </div>
                                </div>

                                <!-- 状态 -->
                                <div
                                    v-else-if="column.field_type=='1' && column.name=='adgroup_display_status'"
                                    :class="getStatusColor(scope.row['adgroup_display_status'], scope.row['adgroup_serving_state_reasons'])">
                                    {{scope.row['adgroup_serving_state_reasons']}}
                                </div>

                                <!-- 投放日期 -->
                                <div v-else-if="column.field_type=='1' && column.name=='start_end_time'">
                                    <p>Start:{{scope.row['start_time']}}</p>
                                    <p>End:{{scope.row['end_time']}}</p>
                                </div>

                                <div v-else-if="column.field_type=='2'">
                                    <div class="currency_flex" v-if="getcurrency(scope.row, column.name)['has']">
                                        <div class="column_name text-nowrap">
                                            {{ getcurrency(scope.row, column.name)['name'] }}
                                        </div>
                                        <div class="column_currency">
                                            {{ getcurrency(scope.row, column.name)['currency'] }}
                                        </div>

                                    </div>
                                    <div class="currency_flex" v-else> {{ getcurrency(scope.row, column.name)['name'] }}</div>
                                </div>

                                <div class="lineheightmax" v-else><span ref="paragraphs">{{scope.row[column.name]}}</span></div>
                            </template>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="component_pagination">
                <el-pagination
                    v-if="pagination"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pn"
                    :page-sizes="[30, 50, 100]"
                    :page-size="rn"
                    :pager-count="5"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCnt">
                </el-pagination>

            </div>

            <el-drawer
                title="嘿嘿"
                :visible.sync="drawer"
                :with-header="false"
                :destroy-on-close="true"
                :before-close="beforeClose"
                size="45%">
                <div class="custom_drawer" v-if="drawer">
                    <div class="title">
                        <span style="font-size: 16px; font-weight: bold;">Details</span>
                        <el-button size="mini" type="primary" :disabled="!pageFuncNames.includes('edit')|| !selectable(tableData[activeIndex])" @click="handleEdit(tableData[activeIndex], 'info')">Edit Ad Group</el-button>
                    </div>
                    <div class="drawer_list">
                        <p class="drawer_list_P">Campaign Group：{{tableData[activeIndex]['campaign_name']}}（ID:{{tableData[activeIndex]['campaign_id']}}）</p>
                        <h4>Basic Information</h4>
                        <div class="drawer_item" v-if="getShowInfoItem(props_params['fields'], 'adgroup_name')">
                            <div>Ad Group Name：</div>
                            <div>
                                <div class="custom_input" :class="[(infoysactive && three_name == 'adgroup_name') ? 'active' : '']" ref="drawer_three">
                                    <el-input
                                        v-if="(!infoysactive || three_name != 'adgroup_name')"
                                        type="textarea"
                                        :autosize="{ minRows: 2, maxRows: 10}"
                                        size="mini"
                                        class="custom_input_el"
                                        :style="{minHeight: '48px'}"
                                        :value="tableData[activeIndex]['adgroup_name']"
                                        @focus="handleFocusInfoNumber(tableData[activeIndex]['adgroup_name'], activeIndex, 'adgroup_name', 'three')"
                                        readonly
                                        ref="myInfonameParagraphread3"
                                        :disabled="isHasAuth('edit_adgroup_name') || !selectable(tableData[activeIndex])"
                                        >
                                    </el-input>
                                    <el-input
                                        v-if="(infoysactive && three_name == 'adgroup_name')"
                                        size="mini"
                                        type="textarea"
                                        :autosize="{ minRows: 2, maxRows: 10}"
                                        placeholder="Please Enter"
                                        class="custom_input_el"
                                        :style="{minHeight: '48px'}"
                                        v-model="tableData[activeIndex]['adgroup_name']"
                                        @blur="handleInfoBlur"
                                        ref="myInfonameParagraphread3"
                                        :disabled="isHasAuth('edit_adgroup_name') || !selectable(tableData[activeIndex])"
                                        >
                                    </el-input>
                                    <div class="custom_input_btn" v-if="(infoysactive && three_name == 'adgroup_name')">
                                        <button class="custom_input_success" :class="{'btn-disabled':btnloading}" :disabled="btnloading"  @click="handleInfoOK(tableData[activeIndex], activeIndex, 'three')"><i class="el-icon-check"></i></button>
                                        <button class="custom_input_close" :class="{'btn-disabled':btnloading}" :disabled="btnloading" @click="handleInfoClose(tableData[activeIndex], activeIndex, 'three')"><i class="el-icon-close"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="drawer_item" v-if="getShowInfoItem(props_params['fields'], 'adgroup_id')">
                            <div>Ad Group ID：</div>
                            <div>{{tableData[activeIndex]['adgroup_id']}}</div>
                        </div>
                        <div class="drawer_item" v-if="getShowInfoItem(props_params['fields'], 'adgroup_status')">
                            <div>Switch：</div>
                            <div>
                                <el-switch
                                    v-model="tableData[activeIndex]['adgroup_status']"
                                    :disabled="isHasAuth('edit_adgroup_status') || !selectable(tableData[activeIndex]) || tableData[activeIndex]['adgroup_status_disabled']"
                                    active-value="ENABLED"
                                    inactive-value="PAUSED"
                                    @change="(val)=>handleSwith(tableData[activeIndex], 'adgroup_status', val)">
                                </el-switch>
                            </div>
                        </div>
                        <div class="drawer_item" v-if="getShowInfoItem(assignObjqx, 'automated_keywords_opt_in') && (tableData[activeIndex]['supply_source'] == '搜索结果'||tableData[activeIndex]['supply_source'] == 'Search Results')">
                            <div>Search Match：</div>
                            <div>{{tableData[activeIndex]['automated_keywords_opt_in']}}</div>
                        </div>
                        <div class="drawer_item" v-if="getShowInfoItem(assignObjqx, 'app_categories') && (tableData[activeIndex]['supply_source'] == '产品页面'||tableData[activeIndex]['supply_source'] == 'Product Page')">
                            <div>App Category：</div>
                            <div>{{tableData[activeIndex]['app_categories']}}</div>
                        </div>
                    </div>
                    <div class="drawer_list" v-if="getShowInfoItem(assignObjqx, 'start_end_time')">
                        <h4>Campaign Duration</h4>
                        <div class="drawer_item">
                            <div>Campaign Start Date：</div>
                            <div>{{tableData[activeIndex]['start_time']}}</div>
                        </div>
                        <div class="drawer_item">
                            <div>Campaign End Date：</div>
                            <div>{{tableData[activeIndex]['end_time']}}</div>
                        </div>
                        <div class="drawer_item" v-if="tableData[activeIndex]['supply_source'] == '搜索结果'||tableData[activeIndex]['supply_source'] == 'Search Results'">
                            <div>Campaign Duration：</div>
                            <div class="drawer_item_time_srcoll" v-if="isObject(tableData[activeIndex]['daypart'])">
                                <div class="drawer_item_time">
                                    <div v-for="(item, index) in Object.keys(tableData[activeIndex]['daypart'])">
                                            <div class="drawer_item_time_title">{{item}}</div>
                                            <div v-for="(itemc, indexc) in tableData[activeIndex]['daypart'][item]" class="drawer_item_time_body">{{itemc}}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>-</div>
                        </div>
                    </div>
                    <div class="drawer_list">
                        <h4>Bid</h4>
                        <div class="drawer_item" v-if="getShowInfoItem(assignObjqx, 'default_bid_amount')">
                            <div>Default Maximum Cost Per Click (CPC)：</div>
                            <div>
                                <div :style="{width: '45%'}" class="custom_input center" :class="[(infoysactive && first_name == 'default_bid_amount') ? 'active' : '']" ref="drawer_first">
                                    <el-input
                                        v-if="(!infoysactive || first_name != 'default_bid_amount')"
                                        size="mini"
                                        class="custom_input_el"
                                        :value="formatNumberWithCommas(Number(tableData[activeIndex]['default_bid_amount']),'default_bid_amount')"
                                        @focus="handleFocusInfoNumber(tableData[activeIndex]['default_bid_amount'], activeIndex, 'default_bid_amount', 'first')"
                                        readonly
                                        ref="myInfonameParagraphread1"
                                        :disabled="isHasAuth('edit_default_bid_amount') || !selectable(tableData[activeIndex])"
                                        >
                                        <template slot="append" v-if="(!infoysactive|| first_name != 'default_bid_amount')">{{tableData[activeIndex]['default_bid_amount_currency']}}</template>
                                    </el-input>
                                    <el-input
                                        v-if="(infoysactive && first_name == 'default_bid_amount')"
                                        size="mini"
                                        placeholder="Please Enter"
                                        class="custom_input_el"
                                        v-model="tableData[activeIndex]['default_bid_amount']"
                                        @blur="handleBlur(activeIndex)"
                                        @input="(value)=>handleInput(value, tableData[activeIndex], 'default_bid_amount')"
                                        ref="myInfonameParagraphread1"
                                        :disabled="isHasAuth('edit_default_bid_amount') || !selectable(tableData[activeIndex])"
                                        >
                                        <template slot="append" v-if="(!infoysactive && first_name == 'default_bid_amount')">{{tableData[activeIndex]['default_bid_amount_currency']}}</template>
                                    </el-input>
                                    <div class="custom_input_btn" v-if="(infoysactive && first_name == 'default_bid_amount')">
                                        <button class="custom_input_success" :class="{'btn-disabled': tableData[activeIndex]['edit_default_bid_amount_disabled']}" :disabled="tableData[activeIndex]['edit_default_bid_amount_disabled']" @click="handleDeOK(tableData[activeIndex], 'default_bid_amount', 'first')"><i class="el-icon-check"></i></button>
                                        <button class="custom_input_close" :class="{'btn-disabled': tableData[activeIndex]['edit_default_bid_amount_disabled']}" :disabled="tableData[activeIndex]['edit_default_bid_amount_disabled']" @click="handleDeClose(tableData[activeIndex], activeIndex, 'first')"><i class="el-icon-close"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="drawer_item" v-if="getShowInfoItem(assignObjqx, 'cpa_goal') && (tableData[activeIndex]['supply_source'] == '搜索结果'||tableData[activeIndex]['supply_source'] == 'Search Results')">
                            <div>Maximum Cost Per Conversion：</div>
                            <div>
                                <div :style="{width: '45%'}" class="custom_input center" :class="[(infoysactive && second_name == 'cpa_goal') ? 'active' : '']" ref="drawer_second">
                                    <el-input
                                        v-if="(!infoysactive || second_name != 'cpa_goal')"
                                        size="mini"
                                        class="custom_input_el"
                                        :value="formatNumberWithCommas(Number(tableData[activeIndex]['cpa_goal']))"
                                        @focus="handleFocusInfoNumber(tableData[activeIndex]['cpa_goal'], activeIndex, 'cpa_goal', 'second')"
                                        readonly
                                        ref="myInfonameParagraphread2"
                                        :disabled="isHasAuth('edit_cpa_goal') || !selectable(tableData[activeIndex])"
                                        >
                                        <template slot="append" v-if="(!infoysactive || second_name != 'cpa_goal')">{{tableData[activeIndex]['cpa_goal_currency']}}</template>
                                    </el-input>
                                    <el-input
                                        v-if="(infoysactive && second_name == 'cpa_goal')"
                                        size="mini"
                                        placeholder="Please Enter"
                                        class="custom_input_el"
                                        v-model="tableData[activeIndex]['cpa_goal']"
                                        @blur="handleBlur(activeIndex)"
                                        @input="(value)=>handleInput(value, tableData[activeIndex], 'cpa_goal')"
                                        ref="myInfonameParagraphread2"
                                        :disabled="isHasAuth('edit_cpa_goal') || !selectable(tableData[activeIndex])"
                                        >
                                        <template slot="append" v-if="(!infoysactive && second_name == 'cpa_goal')">{{tableData[activeIndex]['cpa_goal_currency']}}</template>
                                    </el-input>
                                    <div class="custom_input_btn" v-if="(infoysactive && second_name == 'cpa_goal')">
                                        <button class="custom_input_success" :class="{'btn-disabled': tableData[activeIndex]['edit_cpa_goal_disabled']}" :disabled="tableData[activeIndex]['edit_cpa_goal_disabled']"  @click="handleCpaOK(tableData[activeIndex], 'cpa_goal', 'second')"><i class="el-icon-check"></i></button>
                                        <button class="custom_input_close" :class="{'btn-disabled': tableData[activeIndex]['edit_cpa_goal_disabled']}" :disabled="tableData[activeIndex]['edit_cpa_goal_disabled']" @click="handleCpaClose(tableData[activeIndex], activeIndex, 'second')"><i class="el-icon-close"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="drawer_list">
                        <h4>Audience</h4>
                        <!-- <div class="drawer_item">
                            <div>受众:</div>
                            <div>{{tableData[activeIndex]['targeting_type']}}</div>
                        </div> -->
                        <div class="drawer_item">
                            <div>Device：</div>
                            <div>{{tableData[activeIndex]['device_class']}}</div>
                        </div>
                        <div class="drawer_item">
                            <div>User Type：</div>
                            <div>{{tableData[activeIndex]['app_downloader']}}</div>
                        </div>
                        <div class="drawer_item">
                            <div>Gender：</div>
                            <div>{{tableData[activeIndex]['gender']}}</div>
                        </div>
                        <div class="drawer_item">
                            <div>Age Range：</div>
                            <div>{{tableData[activeIndex]['age']}}</div>
                        </div>
                        <div class="drawer_item">
                            <div>Country：</div>
                            <div>{{tableData[activeIndex]['country']}}</div>
                        </div>
                        <div class="drawer_item">
                            <div>Province/Autonomous Region/Municipality：</div>
                            <div>{{tableData[activeIndex]['admin_area']}}</div>
                        </div>
                        <div class="drawer_item">
                            <div>City：</div>
                            <div>{{tableData[activeIndex]['locality']}}</div>
                        </div>
                    </div>
                </div>
            </el-drawer>

            <el-dialog
                :title="null"
                :visible.sync="dialogVisible"
                :close-on-click-modal=false
                :close-on-press-escape=false
                :show-close=false
                :destroy-on-close=true
                width="450px"
                custom-class="apple-dialog-err">
                <div>
                    <h5 class="tac font16px">{{dialogTypeTitle}}</h5>
                    <p class="tac text-color-error pt10 pb20">Please do not refresh the page, refreshing the page may result in not receiving the latest results in time.</p>
                </div>
            </el-dialog>

            <BatchBudgetModal ref="batchBudgetModal" :list="multipleSelection" @update="getListBody(props_params)" />
            <el-tooltip ref="cellTip" v-model="showPopper" placement="top-start" effect="dark">
                <div class="tip-apple-content" slot="content">{{tipContent}}</div>
            </el-tooltip>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import Query from "../components/query.vue";
    import CustomizeModal from '../modal/customizeModal';
    import API from '@/api/marketManage/apple/index-en';
    import BatchBudgetModal from '../campaign/modal/batchBudgetModal';
    import { cloneDeep, debounce } from 'lodash'
    import utils from '@/libs/utils.js';
    import {
        handleDocumentNoctiyClick,
        get_err_info,
        get_flag_single_post_html,
        get_flag_suc_html,
        get_flag_single_err_html,
        get_flag_mul_err_html
    } from "../components/getFlagHtml.js";
    const other_Table_columns_no_sort = ['start_end_time', 'creation_time']
    import { EarlyWarnMixin } from '@/views/marketingManagement/mixins'
    export default {
        name: "AdGroup",
         mixins: [ EarlyWarnMixin({language: "EN", page: 'adgroup' }) ],
        props:{
            pageDimension:Array,
            pageFields:Array,
            pageFunc:Array,
            zone:String,
            rangeTime:Array,
            mixinLoading:Boolean,
            pageActionNames:Array,
        },
        inject:['priceDecimalConfig'],
        components: {
            Query,
            CustomizeModal,
            BatchBudgetModal,
        },
        data() {
            return {
                pageName:'apple_promotion_manage_adgroup',
                value:true,
                props_params: {}, //query 组件吐出参数 对象形式  (一般用在勾选操作与导出)
                btnloading: false,  //每日预算按钮loading
                active: -1, // 出价点击
                first_name: '', //默认最高付费出价
                second_name: '', //每次转化费用上限
                three_name: '', //广告组名称 显示
                drawer: false, //抽屉
                pagination: true,
                pn: 1,
                rn: 30,
                totalCnt:0,
                selectList: [],
                multipleSelection: [],
                columns: [],
                tableData:[],
                cloneTableData: [],
                customBtnLoading: false, //自定义列按钮loading
                activeIndex: -1, //选中的详情条数
                cacha_money_first: '',  //缓存每日预算
                cacha_money_second: '',  //缓存每日预算
                cacha_name: '', //缓存广告系列名称
                infoValue: false, // 详情开关
                infoactive: false, // 详情广告名称 显示输入与否
                infoysactive: false, //详情每日预算  显示与否
                infoName: '', // 广告系列名称
                show: false, //处理表格头显示后 显示表格
                loading: false, //处理表格loading
                options: [
                    {
                        value: '1',
                        label: 'Switch - Run',
                        children: [
                            {
                                value: 'all',
                                label: 'Select All',
                            }
                        ]
                    },
                    {
                        value: '2',
                        label: 'Switch - Pause',
                    },
                    {
                        value: '3',
                        label: 'Copy',
                    },
                    {
                        value: '4',
                        label: 'Daily Budget',
                    },
                    {
                        value: '5',
                        label: 'Delete',
                    }
                ],
                dialogVisible: false,   //各种错误提示
                dialogBoo: true,   // 是否失败
                dialogType: 1,   //1单个处理 2多个处理
                dialogTypeTitle: 'Request successful, processing…', //显示提示头
                dialogTypeBody: '1000027869，Processing, please wait', //显示提示头
                mulerrIds: '',
                mulErr:'',
                mulexc: '',
                cachaHeader: 1,
                showPopper: false, //浮层提醒
                tipContent: '',    //浮层提醒内容
                exportLoading:false,
                addLoading:false,
            }
        },
        computed:{
            ...mapGetters(['tabs_map', 'apple_reload','apple_list_page_query']),
            decimalConfig(){
                return this.priceDecimalConfig();
            },
            allFilterList(){
                let dimensions =  cloneDeep(this.pageDimension)
                /* 需要过滤掉[操作]列 */
                return dimensions.filter(item=>item.config&&item.name!='operate').map(item=>{
                    item.config = JSON.parse(item.config);
                    return item;
                })
            },
            assignObj() {
                let chone_list = cloneDeep(this.pageDimension)
                let chone_list_pageFields = cloneDeep(this.pageFields)
                let res_dime = chone_list.map(item=>{
                    item['meconfig'] = item['config'] && JSON.parse(item.config);
                    return item;
                })
                let res_pageFields = chone_list_pageFields.map(item=>{
                    // item.config = item['config'] && JSON.parse(item.config);
                    if(item['children']) {
                        item['children'].map(itemc => {
                            itemc['meconfig'] = itemc['config'] && JSON.parse(itemc['config']);
                            return itemc
                        })
                    }
                    return item;
                })
                let baselist = {
                    id : "b_1000",
                    name: 'base',
                    display_name: 'Basic Information',
                    children: res_dime
                }
                return [baselist,...res_pageFields]
            },
            assignObjqx() {
                let chone_list = cloneDeep(this.pageDimension)
                let chone_list_pageFields = cloneDeep(this.pageFields)
                let res_dime = chone_list.map(item=>{
                    return item['name'];
                })
                let qx_res = []
                let res_pageFields = chone_list_pageFields.map(item=>{
                    // item.config = item['config'] && JSON.parse(item.config);
                    if(item['children']) {
                        item['children'].map(itemc => {
                            qx_res.push(itemc['name'])
                        })
                    }
                    return item;
                })
                return [...res_dime,...qx_res]
            },
            getappledialogerr() {
                if(this.mulErr != '' && this.mulexc != '') {
                    return 1
                }else if(this.mulErr != '' || this.mulexc != ''){
                    return 2
                }else{
                    return 3
                }
            },
            pageFuncNames(){
                return (this.pageFunc||[]).map(item=>item.name);
            },
            isEmptySelection(){
                return this.multipleSelection.length<=0;
            },
            isHasKeywordAction(){
                let tabsMap =  this.tabs_map||{};
                let apple =tabsMap.apple||[];
                return apple.map(item=>item.name).includes('apple_keyword');
            },
            firstColumnName(){
                let column = this.columns[0]||{};
                return column.name||'-';
            },
            isHasBatchAuth(){
                let funcNames = this.pageFuncNames||[];
                return funcNames.includes('del')||funcNames.includes('edit_adgroup_status');
            },
        },
        watch: {
            apple_reload: function(val) {
                this.getListBody(this.props_params)
            }
        },
        mounted() {
            this.getEventTip()
            // // 处理表格内部blur事件
            document.addEventListener('click', this.handleDocumentClickFirst);
            // document.addEventListener('click', this.handleDocumentClickSecond);

            this.getListHead((res)=>{
                const fields = res && res.map(item=>item['name'])
                this.props_params['fields'] = []
                this.props_params['fields'] = fields
            })
        },
        beforeDestroy() {
            // 处理表格内部blur事件
            // 在组件销毁前移除全局点击事件监听器
            document.removeEventListener('click', this.handleDocumentClickFirst);
            // document.removeEventListener('click', this.handleDocumentClickInfoMoney);
            document.removeEventListener('click', this.handleDocumentClickInfoFirst);

        },
        methods:{
            getcurrency(rows, name) {
                let name_currency = `${name}_currency`
                if(rows[name_currency]) {
                    return {
                        has: true,
                        name: rows[name],
                        currency: rows[name_currency],
                    }
                }else{
                    return {
                        has: false,
                        name: rows[name]
                    }
                }
            },
            // query 查询  isClear为true：表示点击的是【清空筛选】
            handleQueryClick(params,isClear) {
                console.log('params', params)
                this.$refs.query.setSubmitLoading(true);
                if(isClear){
                    this.$refs.query.setClearLoading(true);
                }
                let range_time = Array.isArray(this.rangeTime) && this.rangeTime.length != 0 ? `${this.rangeTime[0]}/${this.rangeTime[1]}` : ''
                // this.props_params = {...params, range_time: range_time, time_zone: this.zone, pn: this.pn, rn: this.rn}
                this.pn = 1
                this.props_params = Object.assign(this.props_params,params,{range_time: range_time, time_zone: this.zone, pn: this.pn, rn: this.rn})
                // if(this.cachaHeader == 1) {
                //     this.getListHead((res)=>{
                //         const fields = res && res.map(item=>item['name'])
                //         this.props_params['fields'] = []
                //         this.props_params['fields'] = fields
                //         this.getListBody(this.props_params,isClear)
                //     })
                // }else{
                //     this.getListBody(this.props_params,isClear)
                // }
                this.getListBody(this.props_params,isClear)
            },
            getRowKey(row) {
                return row['adgroup_id']
            },
            getShowInfoItem(arr, name) {
                if(Array.isArray(arr) && arr.length != 0) {
                    let isshow = arr.some(item=> item== name)
                    return isshow
                }else{
                    return false
                }
            },
            // 判断是否显示tip事件
            getEventTip() {
                const _this = this;
                const cellTip = this.$refs.cellTip;
                const delay = 200;

                // 超长提示事件
                $(this.$el).on('mouseenter.tdcell', '.lineheightmax', debounce(function() {

                    const $cell = $(this);
                    if ($cell[0].offsetHeight === $cell[0].scrollHeight) {
                        return;
                    }

                    cellTip.referenceElm = $cell[0];
                    _this.showPopper = true;
                    _this.tipContent = $cell.text();
                }, delay))
                .on('mouseleave.tdcell', '.lineheightmax', function() {
                    if (!_this.showPopper) {
                        return;
                    }

                    _this.showPopper = false;
                    setTimeout(() => {
                        _this.showPopper = false;
                    }, delay);
                });
            },
            getshowTip(name) {
                // campaign_name 广告系列 countries_or_regions 国家跟地区 campaign_display_status 状态 company_name  客户 org_name广告系列组 app_info 产品 bloc_name集团
                const showTip = ['adgroup_name','org_name','countries_or_regions', 'campaign_display_status', 'company_name', 'app_info', 'bloc_name']
                if(showTip.includes(name)) {
                    return true
                }else{
                    return false
                }
            },
            // 获取权限
            isHasAuth(name){
                let isauth = this.pageFunc.some(item => item['name'] == name)
                return !isauth
            },
            isObject(value) {
                return typeof value === 'object' && value !== null;
            },
            // 返回投放时间
            // getTimeList(list) {
            //     if(isObject(list)) {

            //     }else{
            //         return '-'
            //     }
            // },
            beforeClose(done) {
                this.tableData[this.activeIndex]['adgroup_name'] = this.tableData[this.activeIndex]['cache_adgroup_name']
                this.tableData[this.activeIndex]['default_bid_amount'] = this.tableData[this.activeIndex]['cache_default_bid_amount']
                this.tableData[this.activeIndex]['cpa_goal'] = this.tableData[this.activeIndex]['cache_cpa_goal']
                document.removeEventListener('click', this.handleDocumentClickInfoFirst);
                done();
            },
            // 获取列表头
            getListHead(callback) {
                this.$refs.query.setSubmitLoading(true);
                this.loading = true
                this.columns.length = 0
                API.getCustomField({field_type: 'apple_promotion_manage_adgroup'}).then(res => {
                    let resData = res.data || []
                    this.selectList = resData
                    const width140 = ['campaign_id', 'org_id', 'adgroup_id', 'account_name_start_date', 'adgroup_id', 'adgroup_display_status', 'operate']
                    const width110 = ['account_yy_type', 'yy_name', 'keyword_status', 'supply_source', 'match_type', 'app_categories', 'automated_keywords_opt_in']
                    this.columns = resData.map(item=>{
                        item["display_name"] = item.label
                        item['align'] = 'left'
                        // 宽度特殊处理
                        if(item['field_type'] == 2) {
                            item['align'] = 'right'
                            let nums = (item['display_name']||'').length
                            /* 曝光均价：单独设置宽度250 */
                            // item['width'] = item.name=='imp_price'?250:((nums * 12)) + 60
                            if(item.name=='imp_price' || item.name == 'local_spend') {
                                item['width'] = 250
                            }else {
                                item['width'] = ((nums * 12)) + 60
                            }
                        }else{
                            if(width140.includes(item.name)) {
                                item['width'] = 120
                            }else if(width110.includes(item.name)){
                                item['width'] = 90
                            }else{
                                item['width'] = 190
                            }
                        }
                        if(item.name == 'adgroup_status') {
                            item['align'] = 'center'
                        }
                        if(item.name == 'default_bid_amount') {
                            item['align'] = 'right'
                        }
                        if(item.name == 'cpa_goal') {
                            item['align'] = 'right'
                        }
                        return item
                    })
                    // this.show = true
                    // this.cachaHeader = 2
                    callback && callback(resData)
                }, err=>{
                    this.loading = false
                    if (err.code == '403') {
                        this.$confirm(err.info||'Request Error', 'Prompt', {
                            confirmButtonText: 'Refresh',
                            cancelButtonText: 'Close',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info)
                })
            },
            setListQueryData(){
                let queryData = {
                    org_id:this.props_params.org_id||[],
                    org_name:this.props_params.org_name||[],
                    campaign_id:this.props_params.campaign_id||[],
                    campaign_name:this.props_params.campaign_name||[],
                    adgroup_id:this.props_params.adgroup_id||[],
                    adgroup_name:this.props_params.adgroup_name||[],
                };

                this.$store.commit('apple/SET_LIST_PAGE_QUERY',queryData);
            },
            //  获取列表体
            getListBody(params,isClear) {
                    this.loading = true
                    this.$refs.query.setSubmitLoading(true);
                    if(isClear){
                        this.$refs.query.setClearLoading(true);
                    }

                    this.setListQueryData();
                    API.getAdgroupList(params).then(res => {
                        this.loading = false
                        this.$refs.query.setSubmitLoading(false);
                        if(isClear){
                            this.$refs.query.setClearLoading(false);
                        }
                        let resData = res.data
                        let table_list = resData.list && resData.list.map(item=>{
                            item['adgroup_status_disabled'] = false  // 开关 disabled  默认关
                            item['delbtn_status_disabled'] = false  // 删除按钮 disabled  默认关
                            item['edit_default_bid_amount_disabled'] = false  // 默认最高出价 默认关
                            item['edit_cpa_goal_disabled'] = false  // 每次妆化费用上限 默认关

                            item['cache_adgroup_name'] = item['adgroup_name']
                            item['cache_default_bid_amount'] = item['default_bid_amount']
                            item['cache_cpa_goal'] = item['cpa_goal']

                            item['cache_adgroup_status'] = item['adgroup_status']
                            item['cache_adgroup_display_status'] = item['adgroup_display_status']
                            item['cache_adgroup_serving_state_reasons'] = item['adgroup_serving_state_reasons']


                            if(item['default_bid_amount'] == '-') {
                                item['default_bid_amount'] = ''
                                item['cache_default_bid_amount'] = ''
                            }else{
                                item['cache_default_bid_amount'] = item['default_bid_amount']
                            }
                            if(item['cpa_goal'] == '-') {
                                item['cpa_goal'] = ''
                                item['cache_cpa_goal'] = ''
                            }else{
                                item['cache_cpa_goal'] = item['cpa_goal']
                            }
                            return item
                        })

                        this.tableData = [resData.total||{}].concat(table_list);
                        this.totalCnt = resData.totalCnt

                        this.active = -1
                    }, err=>{
                        if(err.code =='403'){
                            this.$confirm(err.info, 'Prompt', {
                                confirmButtonText: 'Refresh',
                                cancelButtonText: 'Close',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {
                                    this.loading = false
                                });
                            return
                        }
                        this.loading = false
                        this.$message.error(err.info)
                        this.active = -1
                        this.$refs.query.setSubmitLoading(false);
                        if(isClear){
                            this.$refs.query.setClearLoading(false);
                        }
                    })
            },
            // 获取状态颜色
            getStatusColor(val, reason) {
                let texts = reason !='-' ? 'pointer' : ''
                if(val == 'RUNNING') {
                    return `lineheightmax text-color-success apple_states ${texts}`
                }else if(val == 'ON_HOLD') {
                    return `lineheightmax text-color-failed apple_states ${texts}`
                }else if(val == 'CAMPAIGN_ON_HOLD') {
                    return `lineheightmax text-color-failed apple_states ${texts}`
                }else{
                    return `lineheightmax apple_states ${texts}`
                }
            },
            // 设置不可以选择
            selectable(row, index) {
                if(index===0) return false;
                if(row['adgroup_display_status'] == 'DELETED') {
                    return false
                }else{
                    return true
                }
            },
            // 千分位处理
            formatNumberWithCommas(number,name) {
                // Check if the input is a valid number
                if (isNaN(number) || number == '') {
                    return "-";
                }
                let formattedNumber = number.toLocaleString();

                if(name&&name=='default_bid_amount'){
                    return formattedNumber;
                }else if (formattedNumber.indexOf('.') !== -1) {
                    formattedNumber = parseFloat(number).toFixed(2);
                }
                return formattedNumber;
            },
            // 自定义列
            handleShowDefineRow () {
                this.$refs.refcustomizeModal.showModal();
            },
            // 获取自定义列
            getCustomList(values) {
                console.log('values', values)
                this.customBtnLoading = true
                API.setCustomField({
                    field_type: 'apple_promotion_manage_adgroup',
                    fields: values
                }).then(res => {
                    console.log('res', res)
                    this.customBtnLoading = false
                    this.$refs.refcustomizeModal.handleClose()
                    this.$message({
                        message: res.info,
                        type: 'success'
                    });
                    this.getListHead((res)=>{
                        const fields = res && res.map(item=>item['name'])
                        this.props_params['fields'] = []
                        this.props_params['fields'] = fields

                        if(!fields.includes(this.props_params['order_by'])) {
                            this.props_params['order_by'] = ''
                            this.props_params['order_type'] = ''
                        }
                        this.getListBody(this.props_params)
                    })
                }, (err) => {
                    console.log('error', err);
                    if (err.code == '403') {
                        this.$confirm(err.info||'Request Error', 'Prompt', {
                            confirmButtonText: 'Refresh',
                            cancelButtonText: 'Close',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info)

                })
            },
            // 多选
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // 批量操作
            /**
             * 开 1  ENABLED
             * 关 2  PAUSED
             * 复制 3
             * 每日预算 4
             * 删除 5
             */
            handleCommand(el, index) {
                let selected_list_id = this.multipleSelection.map(item=>item.adgroup_id)
                console.log(el, selected_list_id)
                // 开
                if(el == 1) {
                    if(selected_list_id.length == 1) {
                        let selectIndex = this.tableData.findIndex((element) => element['adgroup_id'] == selected_list_id[0])
                        this.handleSwith(this.tableData[selectIndex], 'campaign_status', 'ENABLED')
                        return
                    }

                    this.handleSwithMul('campaign_status', selected_list_id, 'ENABLED', 'Batch switch-on request successful, processing...')
                }
                // 关
                if(el == 2) {
                    if(selected_list_id.length == 1) {
                        let selectIndex = this.tableData.findIndex((element) => element['adgroup_id'] == selected_list_id[0])
                        this.handleSwith(this.tableData[selectIndex], 'campaign_status', 'PAUSED')
                        return
                    }
                    this.handleSwithMul('campaign_status', selected_list_id, 'PAUSED', 'Batch switch-off request successful, processing...')
                }
                // 批量删除
                if(el == 5) {
                    this.$confirm('Are you sure you want to delete? Deleted items cannot be recovered.！', 'Prompt', {
                        confirmButtonText: 'Confirm',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                        }).then(() => {
                            if(selected_list_id.length == 1) {
                                let selectIndex = this.tableData.findIndex((element) => element['adgroup_id'] == selected_list_id[0])
                                this.fetchdel('del', this.tableData[selectIndex]['adgroup_id'], selectIndex)
                                return
                            }
                            this.fetchdelmul('del', selected_list_id)
                        }).catch(() => {
                    });

                }
                // 单独删除
                if(el == 6) {
                    this.$confirm('Are you sure you want to delete? Deleted items cannot be recovered.！', 'Prompt', {
                        confirmButtonText: 'Confirm',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                        }).then(() => {
                            this.fetchdel('del', this.tableData[index]['adgroup_id'], index)
                        }).catch(() => {
                    });

                }
            },
            handleCascader(value) {
                console.log('value', value)
            },
            showBatchBudgetModal(){
                this.$refs.batchBudgetModal.showModal();
            },
            // 开关  单个
            handleSwith(rows, select_name, status) {
                // 单个请求中
                let flag_single_post_html = get_flag_single_post_html(rows['adgroup_id'])
                let currency_time = new Date().valueOf()
                let current_name = `${select_name}_${currency_time}`
                let current_tip = this.$notify({
                    showClose: false,
                    duration: 0,
                    dangerouslyUseHTMLString: true,
                    message: flag_single_post_html
                });
                // this.notifyarr.push(notifyTip)

                this.$store.commit('apple/ADD_NOTIFY',{
                    id: current_name,
                    value: current_tip,
                });

                rows['adgroup_status_disabled'] = true

                let fetchparams = {adgroup_id: [rows['adgroup_id']], status: status, current_name: current_name}
                this.fetchSwith(fetchparams, current_name, select_name)
            },
            fetchSwith(fetchparams, old_current_name, select_name) {
                API.editAdgroupStatus(fetchparams).then(res=>{
                    let resultData = res.data
                    // 处理单个请求中 关闭
                    let current_closed = this.$store.getters.apple_notify[old_current_name]
                    if(current_closed) {
                        current_closed.close()
                    }
                    // 单个请求成功
                    let flag_single_post_html = get_flag_suc_html(res['info'], resultData['msg'])
                    // let currency_time = new Date().valueOf()
                    // let current_name = `${select_name}_${currency_time}`
                    this.$notify({
                        showClose: false,
                        duration: 5000,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_post_html
                    });

                    // 赋予表格状态
                    let select_id = fetchparams['adgroup_id']
                    let selectIndex = this.tableData.findIndex((element) => element['adgroup_id'] == select_id)
                    if(selectIndex != -1) {
                        this.tableData[selectIndex]['adgroup_status'] = resultData['status']
                        this.tableData[selectIndex]['adgroup_display_status'] = resultData['display_status']
                        this.tableData[selectIndex]['adgroup_serving_state_reasons'] = resultData['serving_state_reasons']

                        this.tableData[selectIndex]['cache_adgroup_status'] = resultData['status']
                        this.tableData[selectIndex]['cache_adgroup_display_status'] = resultData['display_status']
                        this.tableData[selectIndex]['cache_adgroup_serving_state_reasons'] = resultData['serving_state_reasons']

                        this.tableData[selectIndex]['adgroup_status_disabled'] = false
                    }

                },err => {
                    // 处理单个请求中 关闭
                    let resultData = err.data
                    let current_closed = this.$store.getters.apple_notify[old_current_name]
                    if(current_closed) {
                        current_closed.close()
                    }

                    if(err.code =='403'){
                        this.$confirm(err.info, 'Prompt', {
                                confirmButtonText: 'Refresh',
                            cancelButtonText: 'Close',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {});
                            return
                    }


                    let {errIds, mulErr, mulexc} = get_err_info(resultData.data)
                    // 处理单个错误结果
                    let flag_single_err_html = get_flag_single_err_html(err['info'], resultData['msg'], mulErr, mulexc , old_current_name)

                    // let currency_time = new Date().valueOf()
                    // let current_name = `${select_name}_${currency_time}`
                    let current_tip = this.$notify({
                        showClose: false,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_err_html
                    })
                    this.$store.commit('apple/ADD_NOTIFY',{
                        id: `${old_current_name}_close`,
                        value: current_tip,
                    });

                    // 还原表格状态
                    let select_id = fetchparams['adgroup_id']
                    let selectIndex = this.tableData.findIndex((element) => element['adgroup_id'] == select_id)
                    if(selectIndex != -1) {
                        this.tableData[selectIndex]['adgroup_status'] = this.tableData[selectIndex]['cache_adgroup_status']
                        this.tableData[selectIndex]['adgroup_display_status'] = this.tableData[selectIndex]['cache_adgroup_display_status']
                        this.tableData[selectIndex]['adgroup_serving_state_reasons'] = this.tableData[selectIndex]['cache_adgroup_serving_state_reasons']
                        this.tableData[selectIndex]['adgroup_status_disabled'] = false
                    }
                })
            },
            // 开关  多个
            handleSwithMul(select_name , prop_id, status, title) {

                // 多个请求中
                this.dialogVisible = true
                this.dialogTypeTitle= title

                let currency_time = new Date().valueOf()
                let current_name = `${select_name}_${currency_time}`
                let fetchparams = {adgroup_id: prop_id, status: status, current_name: current_name}

                API.editAdgroupStatus(fetchparams).then(res=>{
                    let resultData = res.data

                    // 处理多个个请求中 关闭
                    this.dialogVisible = false
                    this.dialogTypeTitle= ''
                    // 单个请求成功
                    let flag_single_post_html = get_flag_suc_html(res['info'], resultData['msg'])
                    this.$notify({
                        showClose: false,
                        duration: 5000,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_post_html
                    });

                    // 成功赋予表格状态
                    this.getListBody(this.props_params)

                },err => {
                    let resultData = err.data
                    // 处理多个个请求中 关闭
                    this.dialogVisible = false
                    this.dialogTypeTitle= ''
                    if(err.code =='403'){
                        this.$confirm(err.info, 'Prompt', {
                                confirmButtonText: 'Refresh',
                            cancelButtonText: 'Close',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {});
                            return
                    }
                    let {errIds, mulErr, mulexc} = get_err_info(resultData.data)
                    // 处理多个错误结果
                    let flag_mul_err_html = get_flag_mul_err_html(err['info'], resultData['msg'], mulErr, mulexc , fetchparams['current_name'], errIds)

                    let current_tip = this.$notify({
                        showClose: false,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: flag_mul_err_html
                    })
                    this.$store.commit('apple/ADD_NOTIFY',{
                        id: `${fetchparams['current_name']}_close`,
                        value: current_tip,
                    });
                    // 多个失败表格状态不动
                    this.getListBody(this.props_params)
                })
            },
            // 删除  单个
            fetchdel(select_name, prop_id, sel_index) {
                // 单个请求中
                let flag_single_post_html = get_flag_single_post_html(prop_id)

                let currency_time = new Date().valueOf()
                let current_name = `${select_name}_${currency_time}`
                let current_tip = this.$notify({
                    showClose: false,
                    duration: 0,
                    dangerouslyUseHTMLString: true,
                    message: flag_single_post_html
                });
                this.$store.commit('apple/ADD_NOTIFY',{
                    id: current_name,
                    value: current_tip,
                });
                this.tableData[sel_index]['delbtn_status_disabled'] = true

                let fetchparams = {adgroup_id: [prop_id], current_name: current_name}
                this.axiosdel(fetchparams, current_name, select_name)

            },
            axiosdel(fetchparams, old_current_name, select_name) {
                API.delAdgroup(fetchparams).then(res=>{
                    let resultData = res.data

                    // 处理单个请求中 关闭
                    let current_closed = this.$store.getters.apple_notify[old_current_name]
                    if(current_closed) {
                        current_closed.close()
                    }
                    // 单个请求成功
                    let flag_single_post_html = get_flag_suc_html(res['info'], resultData['msg'])
                    // let currency_time = new Date().valueOf()
                    // let current_name = `${select_name}_${currency_time}`
                    this.$notify({
                        showClose: false,
                        duration: 5000,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_post_html
                    });

                    // 赋予表格状态
                    this.getListBody(this.props_params)
                },err => {
                    // 处理单个请求中 关闭
                    let resultData = err.data
                    let current_closed = this.$store.getters.apple_notify[old_current_name]
                    if(current_closed) {
                        current_closed.close()
                    }
                    if(err.code =='403'){
                        this.$confirm(err.info, 'Prompt', {
                                confirmButtonText: 'Refresh',
                            cancelButtonText: 'Close',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {});
                            return
                    }
                    let {errIds, mulErr, mulexc} = get_err_info(resultData.data)
                    // 处理单个错误结果
                    let flag_single_err_html = get_flag_single_err_html(err['info'], resultData['msg'], mulErr, mulexc , old_current_name)

                    let current_tip = this.$notify({
                        showClose: false,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_err_html
                    })
                    this.$store.commit('apple/ADD_NOTIFY',{
                        id: `${old_current_name}_close`,
                        value: current_tip,
                    });
                    // 还原表格状态
                    let select_id = fetchparams['adgroup_id']
                    let selectIndex = this.tableData.findIndex((element) => element['adgroup_id'] == select_id)
                    if(selectIndex != -1) {
                        this.tableData[selectIndex]['delbtn_status_disabled'] = false
                    }
                })
            },
            // 删除 多个
            fetchdelmul(select_name, prop_id) {
                // 多个请求中
                this.dialogVisible = true
                this.dialogTypeTitle= 'Batch delete request successful, processing…'

                let currency_time = new Date().valueOf()
                let current_name = `${select_name}_${currency_time}`
                API.delAdgroup({adgroup_id: prop_id, current_name: current_name}).then(res=>{
                    let resultData = res.data

                    // 处理多个个请求中 关闭
                    this.dialogVisible = false
                    this.dialogTypeTitle= ''

                    // 单个请求成功
                    let flag_single_post_html = get_flag_suc_html(res['info'], resultData['msg'])
                    this.$notify({
                        showClose: false,
                        duration: 5000,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_post_html
                    });

                    // 成功赋予表格状态
                    this.getListBody(this.props_params)
                },err => {
                    let resultData = err.data
                    // 处理多个个请求中 关闭
                    this.dialogVisible = false
                    this.dialogTypeTitle= ''
                    if(err.code =='403'){
                        this.$confirm(err.info, 'Prompt', {
                                confirmButtonText: 'Refresh',
                            cancelButtonText: 'Close',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {});
                            return
                    }
                    let {errIds, mulErr, mulexc} = get_err_info(resultData.data)

                    // 处理多个错误结果
                    let flag_mul_err_html = get_flag_mul_err_html(err['info'], resultData['msg'], mulErr, mulexc , current_name, errIds)

                    let current_tip = this.$notify({
                        showClose: false,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: flag_mul_err_html
                    })
                    this.$store.commit('apple/ADD_NOTIFY',{
                        id: `${current_name}_close`,
                        value: current_tip,
                    });
                    // 还原表格状态
                    this.getListBody(this.props_params)
                })
            },
            // 处理表格内部blur事件
            handleDocumentClickFirst(event) {
                    const targetAreas = this.$refs.table_first
                    let isareas = targetAreas && targetAreas.some(item=> item.contains(event.target))
                    const isOutsideClick = targetAreas && !isareas

                    const targetAreasout = this.$refs.table_second
                    let isareasout = targetAreasout && targetAreasout.some(item=> item.contains(event.target))
                    const isOutsideClickout = targetAreasout && !isareasout

                    if(this.first_name == 'default_bid_amount' && this.active != -1 && !this.drawer) {
                        if (isOutsideClick && isOutsideClickout) {
                            this.tableData[this.active]['default_bid_amount'] = this.tableData[this.active]['cache_default_bid_amount']
                            this.tableData[this.active]['cpa_goal'] = this.tableData[this.active]['cache_cpa_goal']
                            this.active = -1
                            this.second_name = ''
                            this.first_name = ''
                            const targetInput = this.$refs.myParagraphread
                            targetInput && targetInput.forEach(item=>{
                                item.blur()
                            })
                        }
                    }

                    if(this.second_name == 'cpa_goal' && this.active != -1 && !this.drawer) {
                        if (isOutsideClick && isOutsideClickout) {
                            // 如果点击事件发生在指定区域外，隐藏指定区域
                            this.tableData[this.active]['default_bid_amount'] = this.tableData[this.active]['cache_default_bid_amount']
                            this.tableData[this.active]['cpa_goal'] = this.tableData[this.active]['cache_cpa_goal']
                            this.active = -1
                            this.second_name = ''
                            this.first_name = ''

                            const targetInput = this.$refs.myParagraphread
                            targetInput && targetInput.forEach(item=>{
                                item.blur()
                            })
                        }
                    }
            },

            // 表格 出价
            handleDeFocus(val, index, name, type) {
                if(this.isHasAuth('edit_default_bid_amount')) return
                if(this.active != -1) {
                    this.tableData[this.active]['default_bid_amount'] = this.tableData[this.active]['cache_default_bid_amount']
                    this.tableData[this.active]['cpa_goal'] = this.tableData[this.active]['cpa_goal']
                }
                this.first_name = ''
                this.second_name = ''
                if(type == 'first') {
                    this.first_name = name
                }else if(type == 'second') {
                    this.second_name = name
                }
                this.active = index
                this.activeIndex = index
            },
            handleCpaFocus(val, index, name, type) {
                if(this.isHasAuth('edit_cpa_goal')) return
                if(this.active != -1) {
                    this.tableData[this.active]['default_bid_amount'] = this.tableData[this.active]['cache_default_bid_amount']
                    this.tableData[this.active]['cpa_goal'] = this.tableData[this.active]['cpa_goal']
                }
                this.first_name = ''
                this.second_name = ''
                if(type == 'first') {
                    this.first_name = name
                }else if(type == 'second') {
                    this.second_name = name
                }
                this.active = index
                this.activeIndex = index
            },
            // 每日预算 blur
            handleBlur(index) {
                // this.active = -1
            },
            // 修改默认出价
            handleDeOK(values, select_name, type) {
                if(values['default_bid_amount'] == '' || values['default_bid_amount'] == 0) {
                    let m_test = values['default_bid_amount_currency'] != '-' ? values['default_bid_amount_currency'] : ''
                    this.$message.error(`Must be greater than or equal to 0.01${m_test}`);
                    return
                }
                // 单个请求中
                let flag_single_post_html = get_flag_single_post_html(values['adgroup_id'])

                let currency_time = new Date().valueOf()
                let current_name = `${select_name}_${currency_time}`
                let current_tip = this.$notify({
                    showClose: false,
                    duration: 0,
                    dangerouslyUseHTMLString: true,
                    message: flag_single_post_html
                });

                this.$store.commit('apple/ADD_NOTIFY',{
                    id: current_name,
                    value: current_tip,
                });

                values['edit_default_bid_amount_disabled'] = true

                let fetchparams = {adgroup_id:values['adgroup_id'], default_bid_amount: Number(values['default_bid_amount']) , current_name: current_name}
                this.fetchDefault_bid_amount(fetchparams, current_name, select_name)

            },
            fetchDefault_bid_amount(fetchparams, old_current_name, select_name) {
                API.editAdgroupDailyAmount(fetchparams).then(res=>{
                    let resultData = res.data

                    // 处理单个请求中 关闭
                    let current_closed = this.$store.getters.apple_notify[old_current_name]
                    if(current_closed) {
                        current_closed.close()
                    }
                    // 单个请求成功
                    let flag_single_post_html = get_flag_suc_html(res['info'], resultData['msg'])
                    // let currency_time = new Date().valueOf()
                    // let current_name = `${select_name}_${currency_time}`
                    this.$notify({
                        showClose: false,
                        duration: 5000,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_post_html
                    });

                    // 赋予表格状态
                    let select_id = fetchparams['adgroup_id']
                    let selectIndex = this.tableData.findIndex((element) => element['adgroup_id'] == select_id)
                    if(selectIndex != -1) {
                        this.tableData[selectIndex]['default_bid_amount'] = Number(resultData['default_bid_amount'])
                        this.tableData[selectIndex]['cache_default_bid_amount'] = Number(resultData['default_bid_amount'])
                        this.tableData[selectIndex]['edit_default_bid_amount_disabled'] = false
                        if(this.active == selectIndex && this.first_name){
                            this.active = -1
                        }
                    }

                },err => {
                    // 处理单个请求中 关闭
                    let resultData = err.data
                    let current_closed = this.$store.getters.apple_notify[old_current_name]
                    if(current_closed) {
                        current_closed.close()
                    }
                    if(err.code =='403'){
                        this.$confirm(err.info, 'Prompt', {
                                confirmButtonText: 'Refresh',
                            cancelButtonText: 'Close',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {});
                            return
                    }
                    let {errIds, mulErr, mulexc} = get_err_info(resultData.data)
                    // 处理单个错误结果
                    let flag_single_err_html = get_flag_single_err_html(err['info'], resultData['msg'], mulErr, mulexc , old_current_name)

                    let current_tip = this.$notify({
                        showClose: false,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_err_html
                    })
                    this.$store.commit('apple/ADD_NOTIFY',{
                        id: `${old_current_name}_close`,
                        value: current_tip,
                    });

                    // 赋予表格状态
                    let select_id = fetchparams['adgroup_id']
                    let selectIndex = this.tableData.findIndex((element) => element['adgroup_id'] == select_id)
                    if(selectIndex != -1) {
                        this.tableData[selectIndex]['default_bid_amount'] = this.tableData[selectIndex]['cache_default_bid_amount']
                        this.tableData[selectIndex]['edit_default_bid_amount_disabled'] = false
                        if(this.active == selectIndex && this.first_name){
                            this.active = -1
                        }
                    }

                    /* 修复抽屉里修改出价的input框blur问题 */
                    document.body.click();
                })
            },
            // 修改默认出价
            handleCpaOK(values, select_name, type) {
                console.log('values', values['cpa_goal'], values['cpa_goal'] == '0.0', values['cpa_goal'] == '0.00')
                if(values['cpa_goal'] === 0 || values['cpa_goal'] == '0.0' || values['cpa_goal'] == '0.00') {
                    let m_test = ''
                    if(values['cpa_goal_currency'] != '-') {
                        m_test = values['cpa_goal_currency']
                    }else{
                        m_test = values['default_bid_amount_currency'] != '-' ? values['default_bid_amount_currency'] : ''
                    }
                    this.$message.error(`Must be greater than or equal to 0.01${m_test}`);
                    return
                }
                // 单个请求中
                let flag_single_post_html = get_flag_single_post_html(values['adgroup_id'])

                let currency_time = new Date().valueOf()
                let current_name = `${select_name}_${currency_time}`
                let current_tip = this.$notify({
                    showClose: false,
                    duration: 0,
                    dangerouslyUseHTMLString: true,
                    message: flag_single_post_html
                });
                // this.notifyarr.push(notifyTip)

                this.$store.commit('apple/ADD_NOTIFY',{
                    id: current_name,
                    value: current_tip,
                });

                values['edit_cpa_goal_disabled'] = true
                let res_cpa = (values['cpa_goal'] == '' || values['cpa_goal'] == null) ? 0 : Number(values['cpa_goal'])
                let fetchparams = {adgroup_id:values['adgroup_id'], cpa_goal: res_cpa, current_name: current_name}
                this.fetchCpa(fetchparams, current_name, select_name)

            },
            fetchCpa(fetchparams, old_current_name, select_name) {
                API.editAdgroupGoal(fetchparams).then(res=>{
                    let resultData = res.data

                    // 处理单个请求中 关闭
                    let current_closed = this.$store.getters.apple_notify[old_current_name]
                    if(current_closed) {
                        current_closed.close()
                    }
                    // 单个请求成功
                    let flag_single_post_html = get_flag_suc_html(res['info'], resultData['msg'])
                    // let currency_time = new Date().valueOf()
                    // let current_name = `${select_name}_${currency_time}`
                    this.$notify({
                        showClose: false,
                        duration: 5000,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_post_html
                    });

                    // 赋予表格状态
                    let select_id = fetchparams['adgroup_id']
                    let selectIndex = this.tableData.findIndex((element) => element['adgroup_id'] == select_id)
                    if(selectIndex != -1) {
                        this.tableData[selectIndex]['cpa_goal'] = Number(resultData['cpa_goal']) == 0 ? '' : Number(resultData['cpa_goal'])
                        this.tableData[selectIndex]['cache_cpa_goal'] = Number(resultData['cpa_goal']) == 0 ? '' : Number(resultData['cpa_goal'])

                        this.tableData[selectIndex]['cpa_goal_currency'] = resultData['currency']
                        this.tableData[selectIndex]['edit_cpa_goal_disabled'] = false
                        if(this.active == selectIndex && this.second_name){
                            this.active = -1
                        }
                    }

                },err => {
                    // 处理单个请求中 关闭
                    let resultData = err.data
                    let current_closed = this.$store.getters.apple_notify[old_current_name]
                    if(current_closed) {
                        current_closed.close()
                    }
                    if(err.code =='403'){
                        this.$confirm(err.info, 'Prompt', {
                                confirmButtonText: 'Refresh',
                            cancelButtonText: 'Close',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {});
                            return
                    }
                    let {errIds, mulErr, mulexc} = get_err_info(resultData.data)
                    // 处理单个错误结果
                    let flag_single_err_html = get_flag_single_err_html(err['info'], resultData['msg'], mulErr, mulexc , old_current_name)

                    let current_tip = this.$notify({
                        showClose: false,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_err_html
                    })
                    this.$store.commit('apple/ADD_NOTIFY',{
                        id: `${old_current_name}_close`,
                        value: current_tip,
                    });

                    // 赋予表格状态
                    let select_id = fetchparams['adgroup_id']
                    let selectIndex = this.tableData.findIndex((element) => element['adgroup_id'] == select_id)
                    if(selectIndex != -1) {
                        this.tableData[selectIndex]['cpa_goal'] = this.tableData[selectIndex]['cache_cpa_goal']
                        this.tableData[selectIndex]['edit_cpa_goal_disabled'] = false
                        if(this.active == selectIndex && this.second_name){
                            this.active = -1
                        }
                    }

                    /* 修复抽屉里修改出价的input框blur问题 */
                    document.body.click();
                })
            },
            handleDeClose(values, index, type) {
                if(type == 'first') {
                    this.first_name = ''
                }else if(type == 'second') {
                    this.second_name = ''
                }
                values['default_bid_amount'] = this.tableData[index]['cache_default_bid_amount']
                this.active = -1
                this.infoysactive = false
            },
            handleCpaClose(values, index, type) {
                if(type == 'first') {
                    this.first_name = ''
                }else if(type == 'second') {
                    this.second_name = ''
                }
                values['cpa_goal'] = this.tableData[index]['cache_cpa_goal']
                this.active = -1
                this.infoysactive = false
            },
            // 只可以输入数字
            handleInput(val, rows, name, limit = 2) {
                if(rows.default_bid_amount_currency=='USD'&&name=='default_bid_amount'){
                    let USDConfig = this.decimalConfig.find(item=>item.type=='adgroup'&&item.field=='default_bid_amount'&&item.currency=='USD')||{};
                    limit = USDConfig.decimal_places||2;
                }

                let rval = val.replace(/[^0-9\d.]/g, ''); //保留数字

                // rval = rval.replace(/^00/, "0."); //开头不能有两个0
                rval = rval.replace(/^\./g, "0."); //开头为小数点转换为0.
                rval = rval.replace(/\.{2,}/g, "."); //两个以上的小数点转换成一个
                rval = rval.replace(".", "$#$").replace(/\./g, "").replace("$#$", "."); //只保留一个小数点
                /^0\d+/.test(rval) ? rval = rval.slice(1) : ''; //两位以上数字开头不能为0
                // rval = rval.replace(/[^0-9\d.]/g, '').replace(/^(-)?0(?!\.)/g, '')
                const str = '^(\\d+)\\.(\\d{' + limit + '}).*$'
                const reg = new RegExp(str)
                if (limit === 0) {
                    // 不需要小数点
                    rval = rval.replace(reg, '$1')
                } else {
                    // 通过正则保留小数点后指定的位数
                    rval = rval.replace(reg, '$1.$2')
                }
                rows[name] = rval
            },
            // 导出
            handleExport() {
                this.exportLoading = true;
                API.exportAdgroupList(this.props_params,{
                    timeout: 120 * 1000,
                }).then(res => {
                    this.exportLoading = false;
                    console.log('res', res)
                    this.$message({
                        message: res.info,
                        type: 'success'
                    });
                }, (err) => {
                    this.exportLoading = false;
                    if(err.code =='403'){
                        this.$confirm(err.info, 'Prompt', {
                                confirmButtonText: 'Refresh',
                            cancelButtonText: 'Close',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {});
                            return
                    }
                    this.$message.error(err.info||'Request Error');
                })
            },
            // 排序
            handlesortchange({column, prop, order}) {
                //ascending 升   descending 降
                console.log(column, prop, order)
                let order_type = order == 'ascending' ? 'asc' : 'desc'
                this.props_params['order_by'] = prop
                this.props_params['order_type'] = order_type
                this.getListBody(this.props_params)
            },
            // 排序显示
            getsortable(values, show) {
                if(values && values == 1 && other_Table_columns_no_sort.includes(show)) {
                    return 'custom'
                }
                return (values && values == 2) ? 'custom' : false
            },
            renderHeader(h, values, column) {
                let colName = column.name;
                let actionCol = this._findFieldByName(this.pageFields,colName)||{};
                let content_text = column['config'] && JSON.parse(column['config'])['title']
                let content_text1 = actionCol['config'] && JSON.parse(actionCol['config'])['title']
                let content_html = null
                if(column['field_type'] == 2) {
                    content_html = h(
                                    'el-tooltip',
                                        {
                                            props: {
                                            effect: 'dark',
                                            content: content_text1||content_text,
                                            placement: 'top',
                                            },
                                        },
                                        [
                                            h('i', {
                                            class: 'el-icon-question',
                                            style: 'margin-left:2px;'
                                            }),
                                        ]
                                    )
                }
                return h('div', {
                            style: 'display: inline-block;'
                        },
                [
                    h('div', {class: 'render-header-div'}, [
                        h('span', {
                                class: 'render-header-span',
                                style: this.getEarlyWarnThem(column)
                            }, values.column.label),
                        content_html,
                        this.renderEarlyWarnIcon(h, column)
                    ])

                ])
            },
            // 分页 切换条数
            handleSizeChange(val) {
                this.props_params.rn = val
                this.props_params.pn = 1
                this.rn = val
                this.pn = 1
                this.getListBody(this.props_params)
            },
            // 分页 选择页数
            handleCurrentChange(val) {
                this.props_params.pn = val
                this.pn = val
                this.getListBody(this.props_params)
            },
            // 复制
            handlecopy() {
                let copyTxt = this.mulerrIds.join('\r\n');
                console.log('复制', copyTxt)
                utils.setClipboardText(copyTxt);
                this.$message({
                    message: 'Copied successfully',
                    type: 'success'
                });
                this.dialogVisible = false
            },
            // 详情
            handledrawer(val) {
                this.activeIndex = val
                this.first_name = ''
                this.second_name = ''
                this.three_name = ''

                this.drawer = true
                // // 处理详情内部的blur事件
                document.addEventListener('click', this.handleDocumentClickInfoFirst);

            },
            // 详情开关
            handleInfoSwith() {

            },
            // info对的点击
            handleDocumentClickInfoFirst() {
                // if(!this.infoysactive) {
                //     return
                // }
                if((this.first_name != '')) {
                    const targetAreas = this.$refs.drawer_first
                    const isOutsideClick = targetAreas && !targetAreas.contains(event.target)
                    console.log('isOutsideClick', isOutsideClick)
                    if (isOutsideClick) {
                        // 如果点击事件发生在指定区域外，隐藏指定区域
                        this.tableData[this.activeIndex]['default_bid_amount'] = this.tableData[this.activeIndex]['cache_default_bid_amount']
                        this.infoysactive = false
                        this.first_name = ''

                        const targetInput = this.$refs.myInfonameParagraphread1
                        targetInput.blur()
                    }
                }
                if((this.second_name != '')) {
                    const targetAreas = this.$refs.drawer_second
                    const isOutsideClick = targetAreas && !targetAreas.contains(event.target)
                    if (isOutsideClick) {
                        // 如果点击事件发生在指定区域外，隐藏指定区域
                        this.tableData[this.activeIndex]['cpa_goal'] = this.tableData[this.activeIndex]['cache_cpa_goal']
                        this.infoysactive = false
                        this.second_name = ''

                        const targetInput = this.$refs.myInfonameParagraphrea2
                        targetInput.blur()

                    }
                }
                if((this.three_name != '')) {
                    const targetAreas = this.$refs.drawer_three
                    const isOutsideClick = targetAreas && !targetAreas.contains(event.target)
                    if (isOutsideClick) {
                        // 如果点击事件发生在指定区域外，隐藏指定区域
                        this.tableData[this.activeIndex]['adgroup_name'] = this.tableData[this.activeIndex]['cache_adgroup_name']

                        this.three_name = ''

                        console.log('0')
                        const targetInput = this.$refs.myInfonameParagraphread3
                        console.log('00000', targetInput)
                        targetInput.blur()
                        this.infoysactive = false
                        // if(Array.isArray(targetInput) && targetInput.length !=0) {
                        //     console.log('010', targetInput)
                        //     targetInput.forEach(item=>item.blur())
                        // }else{
                        //     targetInput.blur()
                        // }

                    }
                }

            },

            // 抽屉 出价
            handleFocusInfoNumber(val, index, name, type) {
                this.tableData[index]['adgroup_name'] = this.tableData[index]['cache_adgroup_name']
                this.tableData[index]['default_bid_amount'] = this.tableData[index]['cache_default_bid_amount']
                this.tableData[index]['cpa_goal'] = this.tableData[index]['cache_cpa_goal']

                this.first_name = ''
                this.second_name = ''
                this.three_name = ''
                if(type == 'first') {
                    this.first_name = name
                }else if(type == 'second') {
                    this.second_name = name
                }else if(type == 'three') {
                    this.three_name = name
                }
                this.infoysactive = true
            },
            // 详情输入框 blur
            handleInfoBlur() {
                // this.infoactive = false
            },
            // 详情输入框 校验
            handleInfoChange(value) {
                let reg = /[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|[^\x00-\x7F\xA0-\uD7FF\uE000-\uFFFF]/;
                let otherReg = /^[^[\];{}"<>]*$/;
                if(reg.test(value)){
                    this.$message.error('Cannot input [];{}"<> or emojis');
                    return true
                }else if(!otherReg.test(value)) {
                    this.$message.error('Cannot input [];{}"<> or emojis');
                    return true
                }else if(value == ''){
                    this.$message.error('Cannot be empty');
                    return true
                }else if(value.length > 200){
                    this.$message.error('Cannot be empty, up to 200 characters');
                    return true
                }else{
                    return false
                }
            },
            // 修改系列名称
            handleInfoOK(values, index) {
                console.log(values, index)
                let ispu = this.handleInfoChange(values['adgroup_name'])
                if(ispu) return
                this.btnloading = true
                let currency_time = new Date().valueOf()
                let current_name = `editname_${currency_time}`
                API.editAdgroupName({adgroup_id: values['adgroup_id'], adgroup_name: values['adgroup_name']}).then(res=>{
                    let resultData = res.data

                    // 处理单个请求中 关闭
                    let current_closed = this.$store.getters.apple_notify[current_name]
                    if(current_closed) {
                        current_closed.close()
                    }
                    // 单个请求成功
                    let flag_single_post_html = get_flag_suc_html(res['info'], resultData['msg'])
                    let current_tip = this.$notify({
                        showClose: false,
                        duration: 5000,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_post_html
                    });

                     // 赋予表格状态
                    let select_id = values['adgroup_id']
                    let selectIndex = this.tableData.findIndex((element) => element['adgroup_id'] == select_id)
                    if(selectIndex != -1) {
                        this.tableData[selectIndex]['cache_adgroup_name'] = resultData.name
                        this.tableData[selectIndex]['adgroup_name'] = resultData.name
                    }
                    this.btnloading = false
                    this.infoysactive = false
                },err=>{
                    let resultData = err.data
                    let current_closed = this.$store.getters.apple_notify[current_name]
                    if(current_closed) {
                        current_closed.close()
                    }
                    if(err.code =='403'){
                        this.$confirm(err.info, 'Prompt', {
                                confirmButtonText: 'Refresh',
                            cancelButtonText: 'Close',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {});
                            return
                    }
                    let {errIds, mulErr, mulexc} = get_err_info(resultData.data)
                    // 处理单个错误结果
                    let flag_single_err_html = get_flag_single_err_html(err['info'], resultData['msg'], mulErr, mulexc ,current_name)

                    let current_tip = this.$notify({
                        showClose: false,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_err_html
                    })
                    this.$store.commit('apple/ADD_NOTIFY',{
                        id: `${current_name}_close`,
                        value: current_tip,
                    });

                    // 赋予表格状态
                    let select_id = values['adgroup_id']
                    let selectIndex = this.tableData.findIndex((element) => element['adgroup_id'] == select_id)
                    if(selectIndex != -1) {
                        this.btnloading = false
                        this.infoysactive = false
                        this.tableData[selectIndex]['adgroup_name'] = this.tableData[selectIndex]['cache_adgroup_name']
                    }
                })
            },
            handleInfoClose(values, index) {
                this.infoysactive = false
                values['adgroup_name'] = this.cacha_name
            },
            getSearchList(isClear){
                if(!isClear){
                    this.props_params.range_time = this.rangeTime.join('/');
                    this.props_params.time_zone = this.zone;
                    this.getListBody(this.props_params);
                }else{
                    this.$refs.query.resetForm();
                }
            },
            handleClickAdGroupName(row){
                console.log('handleClickAdGroupName',row);
                if(this.isHasKeywordAction){
                    this.$emit('to-page','apple_keyword',{
                        adgroup_id:[row.adgroup_id],
                        adgroup_name:[row.adgroup_name],
                    });

                    // this.$router.push({
                    //     name:'apple_keyword',
                    //     query:{
                    //         adgroup_id:[row.adgroup_id],
                    //         adgroup_name:[row.adgroup_name],
                    //     },
                    //     params:{
                    //         range:this.rangeTime,
                    //         zone:this.zone,
                    //     },
                    // });
                }else{
                    this.$message.error('No keyword page permission, unable to drill down or redirect. Please apply for permissions if needed.');
                }
            },
            handleClickAdd(){
                console.log('handleClickAdd');
                this.addLoading = true;
                API.check_adgroup_add_adgroup().then(()=>{
                    this.addLoading = false;
                    this.$store.commit('apple/SUBMIT_URL_NAME','adgroup_add_adgroup');
                    this.$store.commit('apple/SET_CREATE_TYPE','createGroup');
                    this.$emit('click-add','create',{});
                },err=>{
                    this.addLoading = false;
                    this.$message.error(err.info||'Request Error');
                });
            },
            handleEdit(row, type){
                if(type == 'info') {
                    console.log('handleEdit',row);
                    this.drawer = false
                    setTimeout(() => {
                        this.$store.commit('apple/SET_CREATE_TYPE','editGroup');
                        this.$store.commit('apple/SET_EDIT_INFO',{
                            org_id:row.org_id,
                            adgroup_id:row.adgroup_id,
                            campaign_id: row.campaign_id
                        });
                        this.$emit('click-add','edit',{
                            org_id:row.org_id,
                            adgroup_id:row.adgroup_id,
                        });
                    }, 200);
                }else{
                    console.log('handleEdit',row);
                    this.$store.commit('apple/SET_CREATE_TYPE','editGroup');
                    this.$store.commit('apple/SET_EDIT_INFO',{
                        org_id:row.org_id,
                        adgroup_id:row.adgroup_id,
                        campaign_id: row.campaign_id
                    });
                    this.$emit('click-add','edit',{
                        org_id:row.org_id,
                        adgroup_id:row.adgroup_id,
                    });
                }
                console.log('handleEdit',row);
                this.$store.commit('apple/SET_CREATE_TYPE','editGroup');
                this.$store.commit('apple/SET_EDIT_INFO',{
                    org_id:row.org_id,
                    adgroup_id:row.adgroup_id,
                    campaign_id: row.campaign_id
                });
                this.$emit('click-add','edit',{
                    org_id:row.org_id,
                    adgroup_id:row.adgroup_id,
                });
            },
            _findFieldByName(data, name) {
                for (let item in data) {
                    if (data[item].name == name) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findFieldByName(child, name);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/styles/apple_sd.scss";
    #operation-box ::v-deep{
        .apple-cascader.el-menu--horizontal{
            border-bottom: none;
            .el-submenu__title,.el-menu-item{
                font-size: 12px;
                border-bottom: none;
                padding: 0 15px!important;
            }
            &>.el-submenu .el-submenu__title{
                font-size: 12px;
                padding: 0 15px!important;
                color: #409eff;
                background: #ecf5ff;
                border: solid 1px #b3d8ff;
                height: 28px;
                line-height: 26px;
                border-radius: 3px;
                border-bottom-color: #b3d8ff!important;
                .el-submenu__icon-arrow{
                    color: #409eff;
                    display: inline-block!important;
                }
                &:hover{
                    background: #409eff;
                    border-color: #409eff;
                    color: #fff;
                    .el-submenu__icon-arrow{
                        color: #fff;
                    }
                }
            }

            .el-menu-item:hover{
                background-color:#ecf5ff;
            }
            .err-menu-item:hover{
                background-color:#fef0f0;
            }
        }
    }



.custom_input{
    .el-input__inner{
        padding: 0 8px;
    }
    .el-input-group__append{
        padding: 0 8px;
    }
}
// .com-table-view-apple{
//     .lineheightmax{
//         max-height: 46px;
//         overflow-y: hidden;
//         display: -webkit-box;
//         -webkit-box-orient: vertical;
//         /* 定义显示的行数 */
//         -webkit-line-clamp: 2;
//     }
//     .el-table th.el-table__cell:not(.el-table-column--selection)>.cell{
//         display: flex;
//         align-items: center;
//         position: relative;
//         vertical-align: middle;
//         justify-content: center;
//     }
// }

// .render-header-div{
//     display: flex;
//     align-items: center;
//     .render-header-span{
//         display: inline-block;
//     }
// }
.apple-dialog-err{
    .el-dialog__header{
        padding: 0;
        .el-dialog__title{
            line-height: 0;
        }
    }
    .el-dialog__body{
        padding: 30px 20px 10px 20px;
    }
    .apple-dialog-err-body{
        .a_b_title{
            display: flex;
            align-items: center;
            .el-icon-success{
                color: #52c41a;
                font-size: 32px;
            }
            .el-icon-error{
                color: #ff0000;
                font-size: 32px;
            }
            h5{
                font-size: 16px;
                padding-left: 8px;
            }
        }
        .a_b_body{
            padding-left: 40px;
        }
    }
}
</style>
<style lang="scss" scoped>
    .com-table-view-apple{
        background: #fff;
        /*padding: 10px 10px 10px;*/
        padding: 10px 0 10px;
        border-radius: 3px;
        border: 1px solid #e8eaec;
        margin-top: 10px;
        /*box-shadow: 0 1px 2px 0 rgba(0,0,0,.2);*/
        .operation-box{
            display: flex;
            justify-content:space-between;
            align-items: center;
            margin-bottom: 10px;
            padding: 0 15px;
            .operation-left{
                display: flex;
                justify-content:flex-start;
                align-items: center;
            }
        }
        .component_pagination{
            padding-top: 20px;
            padding-right: 20px;
            text-align: right;
        }
    }
    .custom_input{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 3px;
        padding: 3px;
        .el-input-group__append{
            padding: 0 8px;
        }
        &.active{
            box-shadow: 0 1px 8px #bbb6b6;
        }
        .custom_input_el{
            margin-right: 4px;
            flex: auto;
        }
        .custom_input_btn{
            width: 48px;
            flex: 0 0 48px;
            display: flex;
            justify-content: space-evenly;
            align-items: center;
        }
        .custom_input_success{
            width: 20px;
            height: 20px;
            line-height: 20px;
            border: 2px solid #67C23A;
            border-radius: 10px;
            background-color: #67C23A;
            text-align: center;
            cursor: pointer;
            &.btn-disabled{
                border: 2px solid #9ed881;
                background-color: #9ed881;
                cursor: no-drop;
            }
            i{
                color: #fff;
                font-weight: bold;
            }
        }
        .custom_input_close{
            width: 20px;
            height: 20px;
            line-height: 20px;
            border-radius: 10px;
            border: 2px solid #F56C6C;
            background-color: #F56C6C;
            text-align: center;
            cursor: pointer;
            &.btn-disabled{
                border: 2px solid #fe9999;
                background-color: #fe9999;
                cursor: no-drop;
            }
            i{
                color: #fff;
                font-weight: bold;
            }
        }
    }
    .table_operate{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        span{
            cursor: pointer;
        }
    }
    // .custom_drawer{
    //     padding: 0 8px;
    //     .title{
    //         display: flex;
    //         justify-content: space-between;
    //         align-items: center;
    //         border-bottom: 1px solid #e8eaec;
    //         padding: 8px 4px;
    //     }
    //     .drawer_list{
    //         padding: 8px 0;
    //         h4{
    //             font-size: 14px;
    //             margin-bottom: 8px;
    //         }
    //         .drawer_item{
    //             display:flex;
    //             align-items: center;
    //             padding: 4px 0;
    //             &>div{
    //                 &:first-child {
    //                     width: 100px;
    //                     flex: 0 0 100px;
    //                     padding-left: 16px;
    //                     color: #272727;
    //                 }
    //                 &:last-child {
    //                     flex: auto
    //                 }
    //             }
    //         }
    //     }
    //     .custom_input{
    //         align-items: flex-end;
    //         &.center{
    //             align-items: center;
    //         }
    //     }
    // }
    .custom_drawer{
        padding: 0 8px;
        .title{
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #e8eaec;
            padding: 8px 4px;
        }
        .drawer_list{
            padding: 8px 0;
            h4{
                font-size: 16px;
                margin-bottom: 8px;
                padding-left: 14px;
            }
            .drawer_list_P{
                padding: 8px 0 8px 14px;
                color: #7F7F7F;
                font-size: 14px;
            }
            .drawer_item{
                display:flex;
                align-items: center;
                margin-bottom: 16px;
                &>div{
                    &:first-child {
                        width: 160px;
                        flex: 0 0 160px;
                        padding-left: 32px;
                        padding-right: 8px;
                        color: #7F7F7F;
                        font-size: 14px;
                        line-height: 22px;
                    }
                    &:last-child {
                        flex: auto
                    }
                }
            }
        }
        .custom_input{
            align-items: flex-end;
            margin: 0;
            padding: 0;
            &.center{
                align-items: center;
            }
        }
    }
    .drawer_item_time_srcoll{
        width: 100%;
        overflow-y:auto;
    }
    .drawer_item_time{
        display:flex;

        .drawer_item_time_title{
            width: 100px;
            text-align: center;
            padding: 6px 0;
            // border: 1px solid #ccc;
            font-weight: border;
        }
        .drawer_item_time_body{
            width: 100px;
            padding: 6px 0;
            text-align: center;
            // border: 1px solid #ccc;
            border-top: none;
        }
    }
    .menude{
        color: #ff0000;
        cursor: pointer;
        &.menuDisabled{
            color: #a19999;
            cursor: no-drop;
        }
    }
    .nodata{
        min-height: 300px;
    }
</style>
